import { palette } from './system/palette';

export const status = {
  'status.ai': palette['plum-500'],
  'status.ai.secondary': palette['plum-80'],
  'status.ai.light': palette['plum-30'],
  'status.info': palette['gray-500'],
  'status.info.secondary': palette['gray-80'],
  'status.info.light': palette['gray-30'],
  'status.success': palette['green-600'],
  'status.success.secondary': palette['green-80'],
  'status.success.light': palette['green-30'],
  'status.warning': palette['yellow-500'],
  'status.warning.text': palette['yellow-700'],
  'status.warning.secondary': palette['yellow-80'],
  'status.warning.light': palette['yellow-30'],
  'status.alert': palette['peach-400'],
  'status.alert.secondary': palette['peach-100'],
  'status.danger': palette['red-500'],
  'status.danger.secondary': palette['red-80'],
  'status.danger.light': palette['red-30'],
  'status.active': palette['blue-500'],
  'status.active.secondary': palette['blue-80'],
  'status.active.light': palette['blue-30'],
  'status.inactive': palette['gray-500'],
  'status.inactive.secondary': palette['gray-80'],
  'status.inactive.light': palette['gray-30'],
  'status.new': palette['blue-500'],
  'status.new.secondary': palette['blue-80'],
  'status.new.light': palette['blue-30'],
};
